module.exports = "/next-static/_next/static/images/block_image_three_2x-268d4a1bc8545e703e6af112c5a2e3d3.webp";